<footer class="footer text-center text-secondary" id="app-footer" [ngClass]="{'footer-decline':IsCustomDefault && IsDeclinePage,'footer-3': IsCustomDefault && !IsDeclinePage, 'hide': !IsCustomDefault  }">
  <div class="container">
    <div class="col-12 text-center py-4 container-logos">
      <div *ngIf="showIconInc5000">
        <img
          loading="lazy"
          decoding="async"
          src="assets/images/funnels/Inc5000-logo.png"
          width="75"
          alt="Inc 5000 logo">
      </div>

      <img
        loading="lazy"
        decoding="async"
        [src]="environment.assetsURL + 'img/logos/lets-encrypt.webp'"
        width="280"
        height="104"
        class="footer-lets-encrypt"
        alt="Let's Encrypt">
    </div>

    <div class="col-12 mb-3">
      <p class="fw-bold">*Your lender and insurer might use a different scoring model, or another type of credit
        score altogether.</p>
    </div>

    <div class="col-12">
      <p class="fw-bold m-0">**Scores and rankings shown above are examples only.</p>
    </div>

    <div class="col-md-12">
      <p class="text-white fw-bold m-0">{{brandResources!.textAddressForFooter!}}</p>
    </div>

    <div class="col-12 py-4" *ngIf="IsCustomDefault">
      <img
        loading="lazy"
        decoding="async"
        [src]="environment.assetsURL + brandResources.pathLogoWhite"
        width="4023"
        height="1451"
        class="img-fluid footer-brand-logo"
        alt="Brand logo">
    </div>

    <hr class="border border-1" *ngIf="!IsCustomDefault" />

    <div class="row">
      <div class="col-md-5 text-center text-md-start text-light">
        <p class="mb-2">© COPYRIGHT {{ currentYear }} {{ brandResources.companyTitle! }}. ALL RIGHTS RESERVED.
        </p>
        <p>{{ brandResources.companyTitle! }} is the proud owner of this website.</p>
      </div>

      <div class="col-12 col-md-7 mt-4 mt-md-0 text-lg-end sub-footer-nav sub-footer-2-nav">
        <ul class="p-0">
          <li>
            <a role="button" class="text-light text-decoration-none"
              (click)="funnelService.ClearUserRegister()">Home</a>
          </li>
          <li>
            <a class="text-light text-decoration-none" routerLink="/privacy" target="_blank"
              id="link-privacy-policy" lander-checkout-partner-privacy-link>Privacy policy</a>
          </li>
          <li>
            <a class="text-light text-decoration-none" routerLink="/terms" target="_blank"
              id="link-terms-and-conditions" lander-checkout-partner-terms-link>Terms and Conditions</a>
          </li>
          <li>
            <a class="text-light text-decoration-none" [routerLink]="'/contact'" target="_blank"
              id="link-contact-us">Contact Us</a>
          </li>

          <ng-container *ngIf="IsOrganicFunnel">
            <li>
              <a class="text-light text-decoration-none" [routerLink]="'/contact'" target="_blank"
                id="link-cancel-subscription">Cancel</a>
            </li>
            <li>
              <a class="text-light text-decoration-none" href="{{brandResources.loginURL}}"
                target="_blank">Login</a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</footer>